
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hra",
      function () {
        return require("private-next-pages/hra.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hra"])
      });
    }
  